import { render, staticRenderFns } from "./preUploadTable.vue?vue&type=template&id=50ff8dc9&scoped=true&"
import script from "./preUploadTable.vue?vue&type=script&lang=js&"
export * from "./preUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./preUploadTable.vue?vue&type=style&index=0&id=50ff8dc9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff8dc9",
  null
  
)

export default component.exports